export const reminderConstants = {

    GET_REMINDERS_REQUEST: 'GET_REMINDERS_REQUEST',
    GET_REMINDERS_SUCCESS: 'GET_REMINDERS_SUCCESS',
    GET_REMINDERS_FAILURE: 'GET_REMINDERS_FAILURE',

    ADD_REMINDER_REQUEST: 'ADD_REMINDER_REQUEST',
    ADD_REMINDER_SUCCESS: 'ADD_REMINDER_SUCCESS',
    ADD_REMINDER_FAILURE: 'ADD_REMINDER_FAILURE',

    DELETE_REMINDER_REQUEST: 'DELETE_REMINDER_REQUEST',
    DELETE_REMINDER_SUCCESS: 'DELETE_REMINDER_SUCCESS',
    DELETE_REMINDER_FAILURE: 'DELETE_REMINDER_FAILURE',

}